<template>
  <v-app>
    <v-card class="card-login mx-auto" max-width="400">
      <v-layout>
        <v-flex xs12 class="text-lg-center" style="margin: 3%">
          <v-img
            contain
            src="../assets/logo_login.png"
            max-height="120"
          ></v-img>
        </v-flex>
      </v-layout>

      <v-flex xs12>
        <p
          class="pa-0 ma-0 text-center"
          style="cursor: pointer"
          @dblclick="atualizarApp()"
        >
          Versão : {{ app_version }}
        </p>
      </v-flex>

      <v-layout>
        <v-flex xs12 class="text-lg-center" style="margin: 3% 6% 0% 6%">
          <h4 v-if="!dadosValidos" style="color: red; margin: 0% 0% 2% 0%">
            {{ mensagemErro }}
          </h4>
          <v-text-field
            v-model="email"
            :error-messages="emailErrors"
            outlined
            label="Digite Email"
            @input="$v.email.$touch()"
            @blur="$v.email.$touch()"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 class="text-lg-center" style="margin: 3% 6% 0% 6%">
          <v-text-field
            v-model.trim="password"
            :error-messages="passwordErrors"
            outlined
            label="Digite Senha"
            :type="show1 ? 'text' : 'password'"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="show1 = !show1"
            @input="$v.password.$touch()"
            @blur="$v.password.$touch()"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 class="text-xs-center" style="margin: 3% 6% 0% 6%">
          <v-btn
            block
            color="#216b80"
            :loading="loading"
            :disabled="loading"
            @click="verificarDadosLogin"
          >
            <h4 style="color: #fff">Entrar</h4>
            <template v-slot:loader>
              <span>Verificando...</span>
            </template>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </v-app>
</template>
<script>
import { required, email } from "vuelidate/lib/validators";
import UsuarioAPI from "./../api/usuario";

export default {
  data() {
    return {
      show1: false,
      email: "",
      password: "",
      dadosValidos: true,
      mensagemErro: "",
      loading: false,
      app_version: process.env.VUE_APP_VERSION,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },

  computed: {
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.required && errors.push("Campo Obrigatório.");
      !this.$v.email.email && errors.push("Email Inválido.");
      return errors;
    },
  },

  methods: {
    atualizarApp() {
      document.location.reload(true);
    },
    verificarDadosLogin() {
      if (!this.$v.$invalid) {
        this.login();
      }
    },
    getAcessos() {
      const headers = this.Helpers.iniciarRequisicao();

      UsuarioAPI.getAcessos(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          const acesso = localStorage.getItem("controle");
          const service = localStorage.getItem("service");

          if (response.status == 200) {
            if (response.data.acessos.length === 0) {
              alert("Usuário sem Permissão de Acesso!!!");
              this.Helpers.logout();
            } else {
              localStorage.setItem("urls", response.data.urls);

              if (acesso == 5) {
                this.$router.push({ name: "cadastro_pessoas" });
              } else if (acesso == 4) {
                this.$router.push({ name: "cadastro_assessores" });
              } else if (acesso == 2 && service == "N") {
                this.$router.push({ name: "dashboard_geral" });
              } else if (acesso == 2 && service == "S") {
                this.$router.push({ name: "cadastro_candidatos" });
              } else {
                this.$router.push("/dashboard");
              }
            }
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },
    login() {
      this.loading = true;

      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        email: this.email,
        password: this.password,
      };

      UsuarioAPI.login(headers, params)
        .then((response) => {
          this.loading = false;
          this.dadosValidos = true;

          const token = response.data.token;
          localStorage.setItem("token", token);

          const user = Object.assign({}, response.data.user);

          localStorage.setItem("id", user.id);
          localStorage.setItem("nome", user.name);
          localStorage.setItem("service", user.service);
          localStorage.setItem("equipe", user.idgerente);
          localStorage.setItem("hash_acesso", user.hash_acesso);
          localStorage.setItem("controle", user.idperfil);

          this.getAcessos();
        })
        .catch((error) => {
          this.loading = false;
          this.dadosValidos = false;
          switch (error.response.status) {
            case 401:
              this.mensagemErro = "Dados inválidos!";
              break;

            default:
              this.mensagemErro = "Erro inesperado!";
              break;
          }
        });
    },
  },
};
</script>
<style scoped>
.theme--light.v-application {
  background-size: cover;
  background-color: #2db8a9;
}

.card-login {
  border-radius: 5px;
  height: 420px;
  margin: 10% 35% 15% 35%;
}
</style>
